<template>
  <v-select
    v-model="version"
    :items="versions"
    label="TARMED Tarif"
    :value="selectedVersion"
  ></v-select>
</template>

<script>
  
export default {
  props: {
    selectedVersion: {
      type: String,
      default: "01.09"
    }
  },
  data() {
    return {
      version: this.selectedVersion,
      versions: [
        { text: "01.09", value: "01.09" },
        { text: "01.08.01_BR", value: "01.08.01_BR" }
      ]
    }
  },

  watch: {
    version(version) {
      this.$emit("change-version", version)
    }
  }
}
</script>

<style scoped>
</style>
